export default __webpack_public_path__ + "static/about-us-experience-62e28b58e8287154b1e883694fa2be9a.webp";